import { Box, Flex, Icon, Text, Tooltip } from '@chakra-ui/react';
import { RiAlarmWarningLine, RiArrowRightLine, RiAddLine } from 'react-icons/ri';
import { EmptyState } from '../_ui/components';
import { useCampaignUI } from '../_ui/ui';
import { actorName, formatDate, idOf } from '../_lib/campaignState';
import { historyEntries } from '../_lib/history';
export default function CampaignHistory({ campaign }) {
 const ui = useCampaignUI(); const entries = historyEntries(campaign);
 if (!entries.length) return <EmptyState title='No activity was recorded' description='Creation and lifecycle activity will appear here when the API returns them.' />;
 return <Box position='relative' pl={9} py={2}>
  <Box position='absolute' left='14px' top={3} bottom={3} w='2px' bg={ui.border} aria-hidden='true' />
  {entries.map((entry, index) => <Flex key={`${entry.at}-${entry.kind}-${index}`} position='relative' gap={4} pb={index === entries.length - 1 ? 0 : 6}>
   <Flex position='absolute' left='-35px' boxSize='28px' borderRadius='full' align='center' justify='center'
    bg={entry.kind === 'alert' ? ui.tones.amber.bg : ui.accentSubtle} color={entry.kind === 'alert' ? ui.tones.amber.fg : ui.textPrimary}
    border='3px solid' borderColor={ui.surface} aria-hidden='true'>
    <Icon as={entry.kind === 'alert' ? RiAlarmWarningLine : entry.kind === 'created' ? RiAddLine : RiArrowRightLine} boxSize={3} />
   </Flex>
   <Box minW={0} flex={1}>
    <Flex justify='space-between' gap={2} wrap='wrap'><Text fontSize='sm' fontWeight='semibold' color={ui.textPrimary}>{entry.title}</Text>
     <Text fontSize='xs' color={ui.textMuted}>{formatDate(entry.at, true)}</Text></Flex>
    {entry.detail && <Text fontSize='sm' color={ui.textSecondary} mt={1} overflowWrap='anywhere'>{entry.detail}</Text>}
    <Tooltip label={idOf(entry.by) ? `User ID: ${idOf(entry.by)}` : undefined}>
     <Text fontSize='xs' color={ui.textMuted} mt={1}>{entry.kind === 'alert' ? `${entry.notified} people notified` : `By ${actorName(entry.by, campaign.peopleById)}`}</Text>
    </Tooltip>
   </Box>
  </Flex>)}
 </Box>;
}
